<template>
  <div class="filters__no-results text-center">
    <span class="icon icon-no_results"></span>
    <p>
      {{ stateInfo }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    stateInfo: {
      required: true,
      type: String,
    },
  },
};
</script>



// WEBPACK FOOTER //
// app/javascript/packs/shared/components/empty_state.vue?711604ff